//#region src/file-download.ts
async function e(e, t) {
	if (!t) throw Error("Filename is required to get download URL");
	try {
		return await e.getFileDownloadUrl(t);
	} catch (e) {
		let n = e instanceof Error ? e.message : "Failed to get download URL";
		throw console.error(`Failed to get download URL for file ${t}:`, n), e;
	}
}
async function t(t, n) {
	return n.length === 0 ? [] : (await Promise.allSettled(n.map((n) => e(t, n)))).map((e, t) => {
		let r = n[t];
		if (e.status === "fulfilled") return {
			filename: r,
			url: e.value
		};
		{
			let t = e.reason instanceof Error ? e.reason.message : "Failed to get download URL";
			return console.error(`Failed to get download URL for file ${r}:`, e.reason), {
				filename: r,
				url: "",
				error: t
			};
		}
	});
}
//#endregion
export { e as getCopilotFileDownloadUrl, t as getCopilotFilesDownloadUrls };
